import { isFuture } from 'date-fns';

export default (dates: array) => {
  return dates.filter((date) => isFuture(new Date(date.course_dates_date)));
};
